import React from 'react';
import Dotdotdot from 'react-dotdotdot';

import ProductRating from '../../product/components/product-rating';
import ProductImage from '../../product/components/product-image';
import Modal from '../../shared/components/modal';

import { Helpers } from '../../core/src/helpers';
import '../css/dlp-reviews.less';

class DLPReviews extends React.PureComponent{

    state = {
        modalProduct: null
    };

    toggleModalView = (product) => this.setState({ modalProduct: product });

    renderProductImage = ({images}) => images;

    renderProductReview = (product, isModal) => {
        let { reviews, images, sku, name, linkUrl } = product || {};
        let { text, rating, user, lastSubmissionTime } = reviews && reviews[0] ? reviews[0] : {};
        let image = images && images[0];
        return text && text.length > 0 && (
            <div key={`dlp-review-${sku}`} className="dlp-reviews-tile">
                <div className="dlp-reviews-image-container">
                        <ProductImage 
                            product={{
                                images: [image],
                                sku, 
                                name
                            }} 
                            link={linkUrl} 
                            linkType='relative'
                            lazyLoad={true} 
                            maxImgWidth={270}
                            ImageWrapper={this.renderProductImage}
                        />
                    </div>
                    <div className="dlp-reviews-summary-container">
                        <h1>{name}</h1>
                        <ProductRating rating={rating} />
                        {
                            isModal 
                            ? <div>{text}</div>
                            : <Dotdotdot clamp={5}>
                                <span>{text}</span>
                              </Dotdotdot>
                        }
                        { 
                            isModal ? (
                                <div className="dlp-review-user-info">Written by {user} {lastSubmissionTime ? <div>{`${new Date(lastSubmissionTime).toLocaleDateString()}`}</div> : ''}</div>
                            ) : (
                                <div className="dlp-review-link" onClick={()=>this.toggleModalView(product)}>{'Read the review >'}</div>
                            )
                        }
                    </div>
            </div>
        );
    } 

    getProductReviews = Helpers.memoize( results => {

        try{
            return (
                results.reduce( (productReviews, product ) => {
                    let productReview;
                    if(productReviews.length < 4){
                        productReview = this.renderProductReview(product);
                    }
        
                    if(productReview){
                        productReviews.push(productReview);
                    }
                    return productReviews;
                }, [])
            );
        }catch(e){}

        return null;
    }, (results, keyword) => `${keyword}-${results && results.length}`);

    render(){
        let { results, keyword } = this.props;
        let { modalProduct } = this.state;
        let reviews = this.getProductReviews(results, keyword);
        return reviews && reviews.length >= 2 && (
            <div className="dlp-reviews-wrapper">
                <div className="dlp-reviews-container">
                    { keyword && keyword.length > 0 && <h2 className="dlp-reviews-header">{`Recent ${keyword} Reviews`}</h2> }
                    { reviews }
                    <Modal  isOpen={!!modalProduct} className="dlp-review-modal" closeModal={()=>this.toggleModalView(null)}>
                            { this.renderProductReview(modalProduct, true) }
                    </Modal>
                </div>
            </div>
        );
    }
}

export default DLPReviews;